import Breadcrumb from "component/common/breadcrumb";
import ImageRender from "component/common/ImageRender";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getRaiseTicketDetail } from "reduxStore/action/raiseTicket(Support)Actions";
import strings from "translate/language";
import { raiseTicketStatus } from "utils/constants";
import usePermission from "utils/usePermission";
import { handleDetailResponse, seo } from "utils/utils";

const ViewSupportTicket = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const ticketId = new URLSearchParams(window.location.search).get("ticket_id");
  const [raiseTicketDetail, setRaiseTicketDetail] = useState({});
  const [loginDetail, setLoginDetail] = useState({});
  const raiseTicketDetailSelector = useSelector((state) => state.raiseTicket);
  const loginSelector = useSelector((state) => state.login);
  const navigatpage = async (navname) => {
    navigate(navname);
  };
  const { update, isAdmin } = usePermission({
    update: "update_ticket_status",
  });
  useEffect(() => {
    dispatch(getRaiseTicketDetail({ ticket_id: ticketId }));
  }, [dispatch]);

  useEffect(() => {
    if (raiseTicketDetailSelector.response) {
      const { response } = raiseTicketDetailSelector;
      if (response?.status === 200) {
        setRaiseTicketDetail(handleDetailResponse(response?.data));
      } else {
        setRaiseTicketDetail({});
      }
    }
  }, [raiseTicketDetailSelector]);

  useEffect(() => {
    if (loginSelector.response) {
      const { response } = loginSelector;
      if (response?.status === 200) {
        setLoginDetail(handleDetailResponse(response?.data));
      } else {
        setLoginDetail({});
      }
    }
  }, [loginSelector]);

  useEffect(() => {
    seo({
      title: "View Support Ticket",
      metaDescription: "View support ticket",
      canonicalLink: window.location.href,
    });
  }, []);
  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.supportticketdetails}
        url={"/raise_ticket"}
        parentListing={strings.raiseTicketList}
        titleactive={strings.viewsupportticketdetails}
        isBackBtn={true}
      />
      <div className="container-fluid">
        <div className="row ">
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-header">
                <h5>{strings.supportTicketDetails}</h5>
              </div>
              <div className="card-body pt-0">
                <div className="row pt-0">
                  <div className="col-md-3 align-items-center">
                    <label htmlFor="exampleInputMobileNo">
                      <h6>{strings.ticketNo} </h6>
                    </label>
                  </div>
                  <div className="col-md-7 ">
                    <label htmlFor="exampleInputMobileNo" className="boldText">
                      <h6>
                        {raiseTicketDetail?.ticket_number ||
                          strings.notavailable}{" "}
                      </h6>
                    </label>
                  </div>
                </div>
                <hr />

                <div className="row pt-0">
                  <div className="col-md-3 align-items-center">
                    <label htmlFor="exampleInputMobileNo">
                      {strings.title} :
                    </label>
                  </div>
                  <div className="col-md-7 align-items-center">
                    <label htmlFor="exampleInputMobileNo" className="boldText">
                      {raiseTicketDetail?.title || strings.notavailable}
                    </label>
                  </div>
                </div>
                <hr />
                <div className="row pt-0">
                  <div className="col-md-3 align-items-center ">
                    <label htmlFor="exampleInputMobileNo">
                      {strings.issue} :
                    </label>
                  </div>
                  <div className="col-md-7 align-items-center ">
                    <label htmlFor="exampleInputMobileNo" className="boldText">
                      {raiseTicketDetail?.reason_title || strings.notavailable}
                    </label>
                  </div>
                </div>
                <hr />
                <div className="row pt-0">
                  <div className="col-md-3 align-items-center ">
                    <label htmlFor="exampleInputMobileNo">
                      {strings.status} :
                    </label>
                  </div>
                  <div className="col-md-7 align-items-center ">
                    <label htmlFor="exampleInputMobileNo" className="boldText">
                      {raiseTicketStatus[raiseTicketDetail?.status] ||
                        strings.notavailable}
                    </label>
                  </div>
                </div>
                <hr />
                <div className="row pt-0">
                  <div className="col-md-3 align-items-center">
                    <label htmlFor="exampleInputMobileNo">
                      {strings.description} :
                    </label>
                  </div>
                  <div className="col-md-7 align-items-center">
                    <label htmlFor="exampleInputMobileNo" className="boldText">
                      {raiseTicketDetail?.remark || strings.notavailable}
                    </label>
                  </div>
                </div>
                <hr />

                <div className="row pt-0">
                  <div className="col-md-3 align-items-center">
                    <label htmlFor="exampleInputMobileNo">
                      {strings.createBy} :
                    </label>
                  </div>
                  <div className="col-md-7 align-items-center">
                    <label htmlFor="exampleInputMobileNo" className="boldText">
                      {raiseTicketDetail?.user_name || strings.notavailable}
                    </label>
                  </div>
                </div>
                <hr />
                <div className="row pt-0">
                  <div className="col-md-3 align-items-center">
                    <label htmlFor="exampleInputMobileNo">
                      {strings.updateBy} :
                    </label>
                  </div>
                  <div className="col-md-7 align-items-center">
                    <label htmlFor="exampleInputMobileNo" className="boldText">
                      {raiseTicketDetail?.update_by || strings.notavailable}
                    </label>
                  </div>
                </div>
                <hr />
                {raiseTicketDetail?.close_by && (
                  <div className="row pt-0">
                    <div className="col-md-3 align-items-center">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.closeBy} :
                      </label>
                    </div>
                    <div className="col-md-7 align-items-center">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {raiseTicketDetail?.close_by || strings.notavailable}
                      </label>
                    </div>
                  </div>
                )}
                {raiseTicketDetail?.close_by && <hr />}
                <div className="row pt-0">
                  <div className="col-md-3 align-items-center">
                    <label htmlFor="exampleInputMobileNo">
                      {strings.updateDate} :
                    </label>
                  </div>
                  <div className="col-md-7 align-items-center">
                    <label htmlFor="exampleInputMobileNo" className="boldText">
                      {raiseTicketDetail.updatedDate ? moment(raiseTicketDetail.updatedDate).format(
                        "DD-MM-yyyy hh:mm a"
                      ) : strings.notavailable}
                    </label>
                  </div>
                </div>
                <hr />
                <div className="row pt-0">
                  <div className="col-md-3 align-items-center">
                    <label htmlFor="exampleInputMobileNo">
                      {strings.image} :
                    </label>
                  </div>
                  <div className="col-md-7 align-items-center">
                    {raiseTicketDetail?.image ? <ImageRender
                      baseUrl={raiseTicketDetail?.base_url}
                      imageUrl={raiseTicketDetail?.image}
                      thumbnailUrl={raiseTicketDetail?.image}
                    /> : strings.notavailable}
                  </div>
                </div>
                <hr />

                {(update || isAdmin) && raiseTicketDetail?.status === 1 && (
  !isAdmin ? (
    loginDetail?.user_id !== raiseTicketDetail?.user_id && (
      <div className="row">
        <div className="col-md-12 d-flex justify-content-end">
          <div className="card-footer">
            <button
              className="btn btn-color"
              type="button"
              onClick={() =>
                navigate(`/updatestatus?ticket_id=${raiseTicketDetail._id}`)
              }
            >
              {strings.update}
            </button>
          </div>
        </div>
      </div>
    )
  ) : (
    <div className="row">
      <div className="col-md-12 d-flex justify-content-end">
        <div className="card-footer">
          <button
            className="btn btn-color"
            type="button"
            onClick={() =>
              navigate(`/updatestatus?ticket_id=${raiseTicketDetail._id}`)
            }
          >
            {strings.update}
          </button>
        </div>
      </div>
    </div>
  )
)}

              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row ">
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-header">
                <h5>{strings.raiseReply}</h5>
              </div>
              {raiseTicketDetail?.reply_support_ticket?.length > 0 ? (
                raiseTicketDetail.reply_support_ticket.map((item, index) => {
                  return (
                    <div key={index} className="card-body pt-0">
                      <div className="row pt-0">
                        <div className="col-md-3 align-items-center">
                          <label htmlFor="exampleInputMobileNo">
                            {strings.remark} :
                          </label>
                        </div>
                        <div className="col-md-7 align-items-center">
                          <label
                            htmlFor="exampleInputMobileNo"
                            className="boldText"
                          >
                            {item.remark}
                          </label>
                        </div>
                      </div>
                      <hr />
                      <div className="row pt-0">
                        <div className="col-md-3 align-items-center">
                          <label htmlFor="exampleInputMobileNo">
                            {strings.status} :
                          </label>
                        </div>
                        <div className="col-md-7 align-items-center">
                          <label
                            htmlFor="exampleInputMobileNo"
                            className="boldText"
                          >
                            {raiseTicketStatus[item.status]}
                          </label>
                        </div>
                      </div>
                      <hr />
                      <div className="row pt-0">
                        <div className="col-md-3 align-items-center">
                          <label htmlFor="exampleInputMobileNo">
                            {strings.updateByName} :
                          </label>
                        </div>
                        <div className="col-md-9 align-items-center">
                          <label
                            htmlFor="exampleInputMobileNo"
                            className="boldText"
                          >
                            {item.update_by_name}
                          </label>
                         
                          {loginDetail?.user_id === item?.create_by && (
                            <button
                              className="btn btn-color float-right"
                              type="button"
                              onClick={() =>
                                navigate(
                                  `/edit_reply_ticket?ticket_id=${item._id}`
                                )
                              }
                            >
                              {strings.edit}
                            </button>
                          )}
                        </div>
                      </div>
                      <hr className="class-1 mb-0" />
                    </div>
                  );
                })
              ) : (
                <h5 className="text-center">{strings.notavailable}</h5>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ViewSupportTicket;
